import type { GameModeDefinition } from "../levels/types";

export const captureTheFlagMode: GameModeDefinition = {
  id: "ctf",
  name: "Capture the Flag",
  shortLabel: "CTF",
  description: "Steal the enemy flag and return it to your base.",
  teamBased: true,
  teams: ["alpha", "bravo"],
  timeLimitSeconds: 900,
};